import React, { FC, ReactElement } from 'react'
import { PasswordPopover } from '../password-popover/password-popover'
import { PasswordValidators } from '../../_utils/password-validations'
import { DEFAULT_DRAWER_FORM_ITEM_LAYOUT } from '../../constants'
import { UserDto } from '../../dtos/user'
import { ValidationRule } from '@ant-design/compatible/lib/form/Form'
import { Form, Input } from 'antd'
import { FormInstance } from 'antd/es/form'
import { Rule } from 'antd/lib/form'

type IPasswordFormProps = {
    user: UserDto
    form: FormInstance | undefined
    drawer?: boolean
}

const PasswordForm: FC<React.PropsWithChildren<React.PropsWithChildren<IPasswordFormProps>>> = ({
    user,
    form,
    drawer,
}): ReactElement => {
    const passwordRules: Rule[] = user
        ? []
        : [
              {
                  required: true,
                  message: 'Password is required',
              },
          ]

    const passwordVerifyRules: Rule[] = user
        ? []
        : [
              {
                  required: true,
                  message: 'Password verification is required',
              },
          ]

    const compareToFirstPassword = (rule: ValidationRule, value: string, callback: Function) => {
        if (value && value !== form?.getFieldValue('password')) {
            callback('Passwords do not match')
        } else {
            callback()
        }
    }

    return (
        <>
            <Form.Item
                name="password"
                rules={passwordRules.concat([
                    {
                        validator: new PasswordValidators(user).validate,
                    },
                ])}
                label="Password"
                {...(drawer ? DEFAULT_DRAWER_FORM_ITEM_LAYOUT : null)}
            >
                <PasswordPopover password={form?.getFieldValue('password')}>
                    <Input.Password />
                </PasswordPopover>
            </Form.Item>
            <Form.Item
                name="passwordVerify"
                label="Verify Password"
                {...(drawer ? DEFAULT_DRAWER_FORM_ITEM_LAYOUT : null)}
                rules={passwordVerifyRules.concat([{ validator: compareToFirstPassword }])}
            >
                <Input.Password placeholder="Verify password" />
            </Form.Item>
        </>
    )
}

export { PasswordForm }
